import createEntityReducer from '../../lib/createEntityReducer';

export const STATE_KEY = 'microphoneBrands';

/**
 * reducers
 */
export default createEntityReducer(STATE_KEY);
